var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.mobileView,
              expression: "!mobileView"
            }
          ]
        },
        [
          _c("div", { attrs: { id: "subheader" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "main-container" } }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { attrs: { id: "container" } }, [
              _c("div", { attrs: { id: "list-header-container" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter,
                      expression: "filter"
                    }
                  ],
                  attrs: {
                    id: "busqueda",
                    type: "text",
                    placeholder: "Busqueda de clientes por nombre o código"
                  },
                  domProps: { value: _vm.filter },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.filter = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "list-container" } }, [
                _vm.filtered.length
                  ? _c(
                      "table",
                      { attrs: { cellspacing: "20" } },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _vm._l(_vm.filtered, function(item, key) {
                          return _c("tr", { key: key }, [
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.cliente,
                                    expression: "cliente"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "cliente-" + item.Id
                                },
                                domProps: {
                                  value: item,
                                  checked: _vm._q(_vm.cliente, item)
                                },
                                on: {
                                  change: function($event) {
                                    _vm.cliente = item
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "label",
                                { attrs: { for: "cliente-" + item.Codigo } },
                                [_vm._v(_vm._s(item.Codigo))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "label",
                                { attrs: { for: "cliente-" + item.Id } },
                                [_vm._v(_vm._s(item.Nombre))]
                              )
                            ])
                          ])
                        })
                      ],
                      2
                    )
                  : _c("div", [
                      _vm._v("\n              Sin resultados ...\n          ")
                    ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fh rc",
                staticStyle: { "text-align": "center", "margin-top": "30px" }
              },
              [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: this.$store.state.user.usuario
                          .ClienteAltaHabilitada,
                        expression:
                          "this.$store.state.user.usuario.ClienteAltaHabilitada"
                      }
                    ],
                    attrs: { id: "btncancel" },
                    on: { click: _vm.newClient }
                  },
                  [_vm._v("NUEVO CLIENTE")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { attrs: { id: "btnok" }, on: { click: _vm.next } },
                  [_vm._v("CONTINUAR")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: this.$store.state.user.cliente,
                        expression: "this.$store.state.user.cliente"
                      }
                    ],
                    attrs: { id: "btncancel" },
                    on: { click: _vm.exit }
                  },
                  [_vm._v("CANCELAR")]
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mobileView,
              expression: "mobileView"
            }
          ],
          staticStyle: { "margin-top": "40px" }
        },
        [
          _c(
            "div",
            {
              staticClass: "fh cc",
              staticStyle: {
                width: "100vw",
                height: "4vh",
                background: "#44C7F4",
                color: "white",
                font: "size 12px"
              }
            },
            [_vm._v("Clientes")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "fv ct", staticStyle: { height: "60vh" } }, [
            _c(
              "div",
              {
                staticClass: "fv cc",
                staticStyle: { width: "100vw", height: "20%" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter,
                      expression: "filter"
                    }
                  ],
                  staticStyle: { "font-size": "11px" },
                  attrs: {
                    id: "busqueda",
                    type: "text",
                    placeholder: "Busqueda de clientes por nombre o código"
                  },
                  domProps: { value: _vm.filter },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.filter = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fv ct",
                staticStyle: { width: "100vw", height: "70%", overflow: "auto" }
              },
              [
                _vm.filtered.length
                  ? _c(
                      "table",
                      {
                        staticStyle: { "font-size": "12px" },
                        attrs: { cellspacing: "20" }
                      },
                      _vm._l(_vm.filtered, function(item, key) {
                        return _c("tr", { key: key }, [
                          _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cliente,
                                  expression: "cliente"
                                }
                              ],
                              attrs: {
                                type: "radio",
                                id: "cliente-" + item.Id
                              },
                              domProps: {
                                value: item,
                                checked: _vm._q(_vm.cliente, item)
                              },
                              on: {
                                change: function($event) {
                                  _vm.cliente = item
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "label",
                              { attrs: { for: "cliente-" + item.Codigo } },
                              [_vm._v(_vm._s(item.Codigo))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "label",
                              { attrs: { for: "cliente-" + item.Id } },
                              [_vm._v(_vm._s(item.Nombre))]
                            )
                          ])
                        ])
                      })
                    )
                  : _c("div", [
                      _vm._v("\n              Sin resultados ...\n          ")
                    ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fh cc",
              staticStyle: { width: "100vw", height: "19vh" }
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: this.$store.state.user.usuario
                        .ClienteAltaHabilitada,
                      expression:
                        "this.$store.state.user.usuario.ClienteAltaHabilitada"
                    }
                  ],
                  attrs: { id: "btncancel" },
                  on: { click: _vm.newClient }
                },
                [_vm._v("NUEVO CLIENTE")]
              ),
              _vm._v(" "),
              _c(
                "button",
                { attrs: { id: "btnok" }, on: { click: _vm.next } },
                [_vm._v("CONTINUAR")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: this.$store.state.user.cliente,
                      expression: "this.$store.state.user.cliente"
                    }
                  ],
                  attrs: { id: "btncancel" },
                  on: { click: _vm.exit }
                },
                [_vm._v("CANCELAR")]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "label-container" } }, [
      _c("span", { attrs: { id: "label" } }, [_vm._v("Clientes")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticStyle: { "text-align": "left" } }, [
      _c("th", { attrs: { width: "120", colspan: "2" } }, [_vm._v("# Código")]),
      _vm._v(" "),
      _c("th", [_vm._v("Nombre")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2360d7b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2360d7b4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/preselect/clientes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2360d7b4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/preselect/clientes.vue
// module chunks = 0